module.exports = __webpack_public_path__ + "static/media/SFP.3aa88ffe.gif";